import { render, staticRenderFns } from "./InvoicesAccountsReceivable.vue?vue&type=template&id=61a6b629&scoped=true"
import script from "./InvoicesAccountsReceivable.vue?vue&type=script&lang=js"
export * from "./InvoicesAccountsReceivable.vue?vue&type=script&lang=js"
import style0 from "./InvoicesAccountsReceivable.vue?vue&type=style&index=0&id=61a6b629&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a6b629",
  null
  
)

export default component.exports